import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, LogIn } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import PageAnimator from '../../components/ui/PageAnimator';

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <PageAnimator>
      <div className="flex flex-col items-center justify-center min-h-[80vh] px-4 text-center">
        <motion.div 
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ type: "spring", stiffness: 200, damping: 20 }}
          className="relative mb-8"
        >
          <div className="absolute inset-0 bg-danger-500/10 rounded-full blur-3xl scale-150" />
          <div className="relative bg-surface border border-danger-100 dark:border-danger-900/30 shadow-hp-xl rounded-3xl p-8">
            <ShieldAlert className="w-24 h-24 text-danger-500 opacity-90" />
          </div>
        </motion.div>
        
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-4xl sm:text-5xl font-bold text-primary mb-4"
        >
          Accès Refusé
        </motion.h1>
        
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-lg text-tertiary max-w-md mb-8"
        >
          Vous n'avez pas les permissions nécessaires pour accéder à cette page, ou votre session a expiré.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <button 
            onClick={() => navigate('/login')} 
            className="btn btn-primary flex items-center px-6 py-3 text-base bg-danger-600 hover:bg-danger-700 border-danger-600 hover:border-danger-700"
          >
            <LogIn className="w-5 h-5 mr-2" />
            Se connecter
          </button>
        </motion.div>
      </div>
    </PageAnimator>
  );
}
